import React from 'react';


const ComponentTitle = ({subTitle2,title,subTitle}) => {
    return (
        <div className='component-title'>
            <span className="backdrop text-center" style={{marginTop: !title && '-20px'}}>{subTitle2}</span>
            <span className="subtitle">{title}</span>
            <h3>{subTitle}</h3>
        </div>
    );
};

export default ComponentTitle;